import * as api from '@/api/article'
import Article from '@/store/models/article'
import formData from '@billow/js-helpers/src/utilities/form-data'

export let state = {
  article: new Article,
  articles: {
    data: []
  }
}

export let mutations = {
  setArticles: (state, payload) => state.articles = payload,

  setArticle: (state, payload) => state.article = (new Article).hydrate(payload),
  reset: state => state.article = new Article,
  
  setTitle: (state, payload) => state.article.title = payload,
  setSlug: (state, payload) => state.article.slug = payload,
  setSubTitle: (state, payload) => state.article.sub_title = payload,
  setActive: (state, payload) => state.article.active = payload,
  setAuthor: (state, payload) => state.article.author = payload,
  setShortDescription: (state, payload) => state.article.short_description = payload,
  setBody: (state, payload) => state.article.body = payload,
  setCategoryId: (state, payload) => state.article.category_id = payload,
  setFile: (state, payload) => state.article.file = payload
}

export let actions = {

  paginate: ({ commit }, path) => new Promise((resolve, reject) => {
    api.paginate(path, response => {
      commit('setArticles', response.data)
      resolve()
    }, reject)
  }),

  load: ({ commit }, article) => new Promise((resolve, reject) => {
    api.load(article, response => {
      commit('setArticle', response.data)
      resolve()
    }, reject)
  }),

  create: ({ state, commit }) => new Promise((resolve, reject) => {
    api.create(formData(state.article), () => {
      commit('reset')
      resolve()
    }, reject)
  }),

  save: ({ state, commit }) => new Promise((resolve, reject) => {
    api.save(state.article, () => {
      commit('reset')
      resolve()
    }, reject)
  }),

  removeFile: ({ }, article) => new Promise((resolve, reject) => {
    api.removeFile(article.id, resolve, reject)
  }),

  remove: ({ }, article) => new Promise((resolve, reject) => {
    api.remove(article.id, resolve, reject)
  })

}